import React from 'react';
import Content from 'gatsby-theme-pagebuilder/src/components/content';
import useRating from '../../../../hooks/use-rating';

const RatingText = ({ title, ratingIds }) => {
  const {
    score,
    totalNumberOfReviews,
    percentageRecommendation,
  } = useRating({ ratingIds });
  return (
    <Content>
      <h1>{title}</h1>
      <p>
        {percentageRecommendation}% van de klanten beveelt ons aan
        op basis van meer dan {totalNumberOfReviews} beoordelingen.
        Zo krijgen we een gemiddelde waardering van {score}.
      </p>
    </Content>
  );
};

export default RatingText;
